import { render, staticRenderFns } from "./DiversityDetailCard.vue?vue&type=template&id=61341b2f&scoped=true"
import script from "./DiversityDetailCard.vue?vue&type=script&lang=js"
export * from "./DiversityDetailCard.vue?vue&type=script&lang=js"
import style0 from "./DiversityDetailCard.vue?vue&type=style&index=0&id=61341b2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61341b2f",
  null
  
)

export default component.exports